// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import {Dictionary} from '../../../shared/models/dictionary.model';
import {IBaseType} from '../../../shared/enums/ibase-type.enum';

export interface ITRPCancelReasonType {
    id: number;
    value: string;
    displayValue: string;
    description: string;
    sortOrder: number;
    active: boolean;
}

export class TRPCancelReasonType implements ITRPCancelReasonType, IBaseType {
    public id: number;
    public value: string;
    public displayValue: string;
    public description: string;
    public sortOrder: number;
    public active: boolean;

    /**
		Returns Deal Unwound TRPCancelReasonType
	**/
    get DealUnwound(): ITRPCancelReasonType {
        return this.FromId(1);
    }
    /**
		Returns Entered Incorrect Information TRPCancelReasonType
	**/
    get EnteredIncorrectInformation(): ITRPCancelReasonType {
        return this.FromId(2);
    }
    /**
		Returns Vehicle Sold TRPCancelReasonType
	**/
    get VehicleSold(): ITRPCancelReasonType {
        return this.FromId(3);
    }
    /**
        Returns Cancelled Due to ABV TRPCancelReasonType
    **/
    get CancelledDuetoABV(): ITRPCancelReasonType {
        return this.FromId(4);
    }
    /**
        Returns Fraud TRPCancelReasonType
    **/
    get Fraud(): ITRPCancelReasonType {
        return this.FromId(5);
    }
    /**
        Returns Expired TRPCancelReasonType
    **/
    get Expired(): ITRPCancelReasonType {
        return this.FromId(6);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, value: 'DealUnwound', displayValue: 'Deal Unwound', description: 'Deal Unwound', sortOrder: 1, active: true });
        this._dictionary.add('2', { id: 2, value: 'EnteredIncorrectInformation', displayValue: 'Entered Incorrect Information', description: 'Entered Incorrect Information', sortOrder: 2, active: true });
        this._dictionary.add('3', { id: 3, value: 'VehicleSold', displayValue: 'Vehicle Sold', description: 'Vehicle Sold', sortOrder: 3, active: true });
        this._dictionary.add('4', { id: 4, value: 'CancelledDuetoABV', displayValue: 'Cancelled Due to ABV', description: 'Cancelled Due to ABV', sortOrder: 4, active: true });
        this._dictionary.add('5', { id: 5, value: 'Fraud', displayValue: 'Fraud', description: 'Fraud', sortOrder: 5, active: true });
        this._dictionary.add('6', { id: 6, value: 'Expired', displayValue: 'Expired', description: 'Expired', sortOrder: 6, active: true });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): ITRPCancelReasonType {
        return this._dictionary[id];
    }

    public FromValue(value: string): ITRPCancelReasonType {
        var match = this._dictionary.getValues().filter(function(data) {
            return data.value == value;
        });

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): ITRPCancelReasonType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): ITRPCancelReasonType[] {
        return this.GetAll().filter(function(data) {
            return data.active;
        });
    }

    public Sort(primaryField, secondaryField, reverse): ITRPCancelReasonType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = function(path, reverse, primer, then) {
        var get = function(obj, path) {
                if (path) {
                    path = path.split('.');
                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }
                    return obj[path[len]];
                }
                return obj;
            },
            prime = function(obj) {
                return primer ? primer(get(obj, path)) : get(obj, path);
            };

        return function(a, b) {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
